<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 15 / 16"
    viewBox="0 0 16 15"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M12.15 4.61L9.826 6.679a2.956 2.956 0 0 0-.991 2.208v2.806l-2.072 1.38V8.887c0-.843-.361-1.648-.99-2.208L3.444 4.611a4.126 4.126 0 0 1-1.348-2.549h11.402a4.125 4.125 0 0 1-1.348 2.549zM14.066 1H1.531A.531.531 0 0 0 1 1.531c0 1.48.634 2.891 1.74 3.874l2.326 2.067c.403.359.634.874.634 1.414v5.179c0 .423.473.677.826.442l3.133-2.09a.531.531 0 0 0 .237-.441v-3.09c0-.54.231-1.055.635-1.414l2.325-2.067a5.187 5.187 0 0 0 1.74-3.874.531.531 0 0 0-.531-.531z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width=".5"
          d="M12.15 4.61L9.826 6.679a2.956 2.956 0 0 0-.991 2.208v2.806l-2.072 1.38V8.887c0-.843-.361-1.648-.99-2.208L3.444 4.611a4.126 4.126 0 0 1-1.348-2.549h11.402a4.125 4.125 0 0 1-1.348 2.549zM14.066 1H1.531A.531.531 0 0 0 1 1.531c0 1.48.634 2.891 1.74 3.874l2.326 2.067c.403.359.634.874.634 1.414v5.179c0 .423.473.677.826.442l3.133-2.09a.531.531 0 0 0 .237-.441v-3.09c0-.54.231-1.055.635-1.414l2.325-2.067a5.187 5.187 0 0 0 1.74-3.874.531.531 0 0 0-.531-.531z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 16,
    },
  },
};
</script>
